var render = function render(){var _vm=this,_c=_vm._self._c;return _c('piece-card',{attrs:{"title":"人流动态"}},[_c('div',{staticClass:"crowd-list flex-box"},_vm._l((_vm.showList),function(item,index){return _c('InfoCard',{key:index,staticClass:"info-item flex-grow",attrs:{"title":item.title,"value":item.value}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }